const state = {
    taxs: [],
    taxId: [],
    loading: false
};

export default state;

